import { Shield, FileText, Database, Clock, CheckCircle } from "lucide-react";

export default function Compliance() {
  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <h1 className="text-2xl font-bold text-ink-900">Compliance & sikkerhet</h1>
        <p className="text-[13px] text-ink-500 mt-1">Hvordan Contrack oppfyller norske og europeiske krav</p>
      </div>

      <Section icon={FileText} title="Bokføringsloven (§ 13)">
        Alle fakturaer, kontrakter og audit-logger lagres i minimum <strong>5 år</strong> i tråd med
        bokføringslovens krav til oppbevaring av primærdokumentasjon. Data lagres i Microsoft Azure
        Norge (Norway East-region).
      </Section>

      <Section icon={Database} title="GDPR / Personvernforordningen">
        Vi er behandlingsansvarlig for personopplysninger. Vi tilbyr databehandleravtale (DPA) for
        kunder ved forespørsel. Brukere har rett til innsyn, retting, sletting og dataportabilitet.
        Data eksporteres som strukturert JSON via &quot;Slett konto&quot;-funksjonen.
      </Section>

      <Section icon={Shield} title="Datasikkerhet">
        <ul className="list-disc pl-5 space-y-1">
          <li>Kryptering i transit: TLS 1.2+</li>
          <li>Kryptering i hvile: AES-256 (Azure Storage)</li>
          <li>Passord: bcrypt med salting</li>
          <li>OAuth-tokens: Fernet-kryptert i database</li>
          <li>Account lockout etter 5 mislykkede login (15 min)</li>
          <li>Audit log på alle write-handlinger</li>
        </ul>
      </Section>

      <Section icon={Clock} title="Backup & disaster recovery">
        <ul className="list-disc pl-5 space-y-1">
          <li>Daglige backups av prod-database (PostgreSQL Flexible Server)</li>
          <li>Retention: 30 dager</li>
          <li>Point-in-time restore innenfor backup-vinduet</li>
        </ul>
      </Section>

      <Section icon={CheckCircle} title="NS 8405/8407 + FIDIC-støtte">
        Contrack støtter standardkontraktene NS 8405, NS 8407 og FIDIC Red/Yellow/Silver Book.
        AI-analysen forstår kontrakts-spesifikke begreper som forsinkelsesbot, mengdejustering,
        endringsordrer og milepælsbetalinger.
      </Section>
    </div>
  );
}

function Section({ icon: Icon, title, children }: any) {
  return (
    <div className="bg-white border border-surface-200 rounded-2xl p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 bg-brand-50 text-brand-600 rounded-xl flex items-center justify-center">
          <Icon className="w-5 h-5" />
        </div>
        <h2 className="text-[15px] font-semibold text-ink-900">{title}</h2>
      </div>
      <div className="text-[13px] text-ink-700 leading-relaxed">{children}</div>
    </div>
  );
}
